/* eslint-disable react-hooks/exhaustive-deps */
import * as rfc6902 from 'rfc6902';
import React, { ChangeEvent, useEffect, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { updateUserRequest } from '../../store/user-management/actions';
import { UserInfo } from '../../store/user-management/types';
import { get } from '../../utils/callApi';
import { useParams, useLocation } from 'react-router-dom';
import { CeclApiState, UserTypes } from '../../store/ceclapi/types';
import { updateUserRolesRequest } from '../../store/user-management/actions';

export interface RolePatch {
  role: string;
  enabled: boolean
}

const initialState = {
  initialUser: undefined,
  user: undefined,
  userRoles: undefined,
  mounted: false,
  userPatch: (initialUser, currentUser) => rfc6902.createPatch(initialUser, currentUser),
  submitting: false,
};

type State = {
  initialUser?: UserInfo;
  user?: UserInfo;
  userRoles?: any[];
  mounted: boolean;
  userPatch: (initialUser: UserInfo, currentUser: UserInfo) => rfc6902.Operation[];
  submitting: boolean;
};

export const actions = {
  INPUT_CHANGE: 'INPUT_CHANGE',
  TOGGLE_PERMISSION: 'TOGGLE_PERMISSION',
  SET_USER: 'SET_USER',
  SET_USER_ROLES: 'SET_USER_ROLES',
  MOUNT: 'MOUNT',
  TOGGLE_SUBMITTING: 'TOGGLE_SUBMITTING',
  UNMOUNT: 'UNMOUNT',
};

type Action = {
  type: typeof actions[keyof typeof actions];
  payload?: any;
};

export const toBool: (pred: any) => boolean = pred => {
  if (typeof pred === 'string') {
    if (pred === 'False') {
      return false;
    }
    if (pred === 'True') {
      return true;
    }
  }

  if (typeof pred === 'boolean') {
    return pred;
  }
  if (pred === null || pred === undefined) {
    return false;
  }
  return false;
};

const reducer: (state: State, action: Action) => State = (state, action) => {
  switch (action.type) {
    /*
    ? Set initial User
    ** This is the default redux state for "auth.user"
    */
    case actions.SET_USER: {
      return { ...state, initialUser: action.payload, user: action.payload };
    }

    case actions.SET_USER_ROLES: {
      return { ...state, userRoles: action.payload };
    }

    case actions.TOGGLE_PERMISSION: {
      let payload: { field: string };
      payload = action.payload;

      let value: any = !toBool(state.user[payload.field]);

      return {
        ...state,
        user: {
          ...state.user,
          [payload.field]: value,
        },
      };
    }

    /*
    ? Handle Input Change
    ** Changes user info on input change
    */
    case actions.INPUT_CHANGE: {
      
      let payload: { name: string; value: string };
      payload = action.payload;
      console.log(payload.name + " " + payload.value)
      if (payload.name === 'smsNumber') {
      }
      return {
        ...state,
        user: { ...state.user, [payload.name]: payload.value },
      };
    }

    /*
    ? Sets mounted to true
    ** Set this to true once you have all your data you need for component to render
    */
    case actions.MOUNT: {
      return { ...state, mounted: true };
    }

    case actions.UNMOUNT: {
      return { ...state, mounted: false };
    }

    case actions.TOGGLE_SUBMITTING: {
      return { ...state, submitting: !state.submitting };
    }
    default:
      return state;
  }
};

const useUserProfileReducer = () => {
  const { id: userId } = useParams();
  const dis = useDispatch();
  const [state, dispatch] = useReducer(reducer, initialState);
  const cecl = useSelector<ApplicationState, CeclApiState>(state => state.cecl);
  const [adminDialog, setAdminDialog] = React.useState(false);
  const [adminDialogAgree, setAdminDialogAgree] = React.useState(false);

  const [enableAdmin, setEnableAdmin] = React.useState(false);

  const setUser = user => {
    dispatch({ type: actions.SET_USER, payload: user });
  };

  const setUserRoles = roles => {
    dispatch({ type: actions.SET_USER_ROLES, payload: roles });
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { name, value } = e.currentTarget;

    dispatch({
      type: actions.INPUT_CHANGE,
      payload: { name, value },
    });
  };

  const toggleSubmitting = () => dispatch({ type: actions.TOGGLE_SUBMITTING });

  const togglePermission = (field: string) =>
    dispatch({ type: actions.TOGGLE_PERMISSION, payload: { field } });

  const updateUser = async () =>{
    if(state.userPatch(state.initialUser, state.user).length > 0){
      dis(updateUserRequest(state.user.objectId, state.userPatch(state.initialUser, state.user)));
    }
  }

  const updateUserRoles = () => {
    if(enableAdmin && !state.initialUser?.roles.includes("CECLAdmin")){
      const rolePatch: RolePatch = {
        role: "CECLAdmin",
        enabled: true
      }
      dis(updateUserRolesRequest(state.user.objectId, rolePatch));
      state.user.roles.push("CECLAdmin");
    }

    if(!enableAdmin && state.initialUser?.roles.includes("CECLAdmin")){
      const rolePatch: RolePatch = {
        role: "CECLAdmin",
        enabled: false
      }
      let roles = state.user?.roles.slice();
      const index = roles.indexOf("CECLAdmin");
      roles.splice(index, 1);
      state.user.roles = roles;
      dis(updateUserRolesRequest(state.user.objectId, rolePatch));
    }
  }

  const handleSubmit: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void = event => {
    event.preventDefault();
    toggleSubmitting();

    if(!state.initialUser?.roles.includes("CECLAdmin") && enableAdmin && !adminDialogAgree){
      setAdminDialog(true);
      toggleSubmitting();
      return;
    }

    Promise.all([updateUserRoles(),updateUser()]).then(() => {
      setUser(state.user)
    })

  };

  const handleSubmit2: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void = event => {
    event.preventDefault();
    toggleSubmitting();

    Promise.all([updateUserRoles(),updateUser()]).then(() => {
      setUser(state.user)
    })
  }

  const edited = () => {
    if (state?.initialUser){

      let patch = state.userPatch(state.initialUser, state.user);
      return patch.length !== 0 ||
      (enableAdmin && !state.initialUser?.roles.includes("CECLAdmin")) ||
      (!enableAdmin && state.initialUser?.roles.includes("CECLAdmin"))
    }
    return false;
  };

  const mount = () => dispatch({ type: actions.MOUNT });

  useEffect(() => {
    if (cecl.user && !cecl.user.loading && !state.submitting) {
      if (cecl.user.userType == UserTypes.Admin && userId !== undefined && state.user === undefined) {
        get(`api/usermanagement/users/${userId}`)
          .then(data => {
            setUser(data);
            setUserRoles(data.roles);
            setEnableAdmin(data?.roles.includes("CECLAdmin"))
          })
          .catch(error => console.log('There was an error fetching the user', error));
      } else if (state.user === undefined) {
        get(`api/usermanagement/users/${cecl.user.userObjectId}`)
          .then(data => {
            setUser(data);
            setEnableAdmin(data?.roles.includes("CECLAdmin"))
          })
          .catch(error => console.log('There was an error fetching the user', error));
        setUserRoles(cecl.user.roles);
      }
    }

    if (!cecl?.user?.loading && state?.user && state?.userRoles) {
      mount();
    }
}, [cecl.user.userObjectId, state.user, state.userRoles, state.mounted, state.submitting, dis]);

  return {
    ...state,
    handleInputChange,
    handleSubmit,
    togglePermission,
    dispatch,
    edited: edited(),
    adminDialog,
    setAdminDialog,
    setAdminDialogAgree,
    adminDialogAgree,
    setEnableAdmin,
    enableAdmin,
    handleSubmit2
  };
};

export default useUserProfileReducer;
